import { TFunction } from 'i18next';
/* istanbul ignore file */
import { IRequisition } from './myOpenRequisition.model';

export const sortingOptions = (translate: TFunction) => [
  {
    value: 'ascending',
    label: translate('mostRecentlyUpdated'),
    sortFunction: (a: IRequisition, b: IRequisition) => {
      const aUpdateDate = new Date(a.lastUpdatedDate || a.dateOpened);
      const bUpdateDate = new Date(b.lastUpdatedDate || b.dateOpened);
      return aUpdateDate < bUpdateDate ? 1 : aUpdateDate > bUpdateDate ? -1 : 0;
    },
  },
  {
    value: 'descending',
    label: translate('leastRecentlyUpdated'),
    sortFunction: (a: IRequisition, b: IRequisition) => {
      const aUpdateDate = new Date(a.lastUpdatedDate || a.dateOpened);
      const bUpdateDate = new Date(b.lastUpdatedDate || b.dateOpened);
      return aUpdateDate > bUpdateDate ? 1 : aUpdateDate < bUpdateDate ? -1 : 0;
    },
  },
];
